import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    bodyText: {
        marginBottom: 20
    },
    validationAlert: {
        paddingTop: 7.5,
        paddingBottom: 7.5
    },
    dateRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 20
    },
    dateLabel: {
        margin: '0px 10px 0px 0px',
        whiteSpace: 'nowrap'
    },
    datePicker: {
        width: 140
    }
};
